/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Lib dependencies
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

// Services
import { MeetingService } from "@/services/meeting.service";
import { Meeting } from "@/types/meeting";

/* -------------------------------------------------------------------------- */
/*                                Meeting Hook                                */
/* -------------------------------------------------------------------------- */
const meetingService = new MeetingService();

type UseMeetingProps = {
  id: string;
};

const meetingQueryOptions = ({
  id,
}: UseMeetingProps): UseQueryOptions<Meeting> => ({
  queryFn: () => meetingService.getOne(id),
  queryKey: ["meeting", id],
});

const useMeeting = ({ id }: UseMeetingProps) => {
  const { data, isPending } = useQuery(meetingQueryOptions({ id }));

  return { data, isPending };
};

export { useMeeting, meetingQueryOptions };
